import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import TextField from '@material-ui/core/TextField'
import { controlHasError } from '../../lib/errorHandler'
import PrintText from '../../lib/PrintText'

export default function UstalenieWynikuFinansowegoOrazSposobuSporzadzenia(
  props,
) {
  return (
    <ExpandablePanel title="ZASADY USTALENIA WYNIKU FINANSOWEGO ORAZ SPOSOBU SPORZĄDZENIA SPRAWOZDANIA FINANSOWEGO">
      <form autoComplete="off" className="subsection">
        {props.czyPodsumowanie ? (
          <PrintText
            text={
              props.data.UstalenieWynikuFinansowegoOrazSposobuSporzadzenia
            }
          />
        ) : (
          <TextField
            error={controlHasError(
              props.errors,
              'UstalenieWynikuFinansowegoOrazSposobuSporzadzenia',
              props.data.UstalenieWynikuFinansowegoOrazSposobuSporzadzenia,
            )}
            name="UstalenieWynikuFinansowegoOrazSposobuSporzadzenia"
            label="Opis"
            multiline
            variant="outlined"
            title={props.data.UstalenieWynikuFinansowegoOrazSposobuSporzadzenia}
            defaultValue={
              props.data.UstalenieWynikuFinansowegoOrazSposobuSporzadzenia
            }
            onBlur={(e) =>
              props.onSetSectionData(
                'UstalenieWynikuFinansowegoOrazSposobuSporzadzenia',
                e.target.value,
              )
            }
          />
        )}
      </form>
    </ExpandablePanel>
  )
}
